import React from 'react';

import { i18n } from './i18n';

export default function Paras({ path, start = 0, end, skip, doReplace }) {
    let keys = Object.keys(i18n(path, { md : false }));

    if (start || end) {
        keys = keys.slice(start, (end || keys.length) + 1);
    }

    if (skip) {
        skip = Array.isArray(skip) ? skip : [ skip ];

        keys = keys.filter((k, idx) => !skip.includes[idx]);
    }

    return <>
        {keys.map(key =>
            <p key={key}>{i18n(`${path}.${key}`, { doReplace })}</p>
        )}
    </>;
}
